import { useEffect, useState } from 'react';
import { appFirebase } from '../../../firebase/credenciales';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import './cargar.css';
import { FaCopy } from 'react-icons/fa';
import Swal from "sweetalert2";
import CargaNequitarjet from './cargaNequi';

// Inicializar el servicio de almacenamiento de Firebase
const storage = getStorage(appFirebase);

const CargaNequi = ({ dataEmpresa, dataUser, socket, dataCargaNequi }) => {
    // Estados para manejar los datos del formulario, archivo y otros estados
    const [file, setFile] = useState(null);
    const [espera, setEspera] = useState(false);
    const [cargaNequi, setCargaNequi] = useState([]);
    const [formData, setFormData] = useState({
        uid: dataUser.uid,
        monto: '',
        saldo: dataUser.saldo
    });

    // Actualiza el estado de cargaNequi cuando cambia dataCargaNequi
    useEffect(() => {
        if (dataCargaNequi) {
            // Filtrar los datos de cargaNequi correspondientes al usuario actual
            const array123 = dataCargaNequi.filter(obj => obj.uid === dataUser.uid);
            setCargaNequi(array123);
        }
    }, [dataCargaNequi, dataUser.uid]);

    // Escucha el evento 'ReponseCargaNequi' del servidor y maneja la respuesta
    useEffect(() => {
        socket.on('ReponseCargaCuenta', (response) => {
            if (response.uid === dataUser.uid) {
                Swal.fire(response.message);
                setEspera(false);  // Detener el estado de espera
                // Reiniciar los valores del formulario
                setFormData({
                    id: dataUser.sub,
                    monto: 10000,
                    saldo: dataUser.saldo
                });
                setFile(null);  // Reiniciar el archivo seleccionado
            }
        });

        // Limpiar el listener del socket cuando el componente se desmonta
        return () => {
            socket.off('ReponseCargaNequi');
        };
    }, [socket, dataUser.uid, dataUser.saldo]);

    // Manejador de cambios en los inputs del formulario
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
    };

    // Manejador de cambios en el archivo de comprobante subido
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    // Copiar número de Nequi al portapapeles
    const handleCopy = () => {
        const phoneNumber = dataEmpresa.nequi;
        navigator.clipboard.writeText(phoneNumber);  // Copiar el número
        Swal.fire("Número copiado: " + phoneNumber);  // Mostrar notificación
    };

    // Manejador del envío del formulario
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            Swal.fire('Por favor, sube el comprobante de pago.');  // Validar si no hay archivo seleccionado
            return;
        }
        try {
            const storageRef = ref(storage, `comprobantes/${file.name}`);  // Crear una referencia en el almacenamiento
            await uploadBytes(storageRef, file);  // Subir el archivo
            const fileUrl = await getDownloadURL(storageRef);  // Obtener la URL de descarga del archivo
            const now = new Date();  // Obtener la fecha actual

            // Emitir evento al servidor con los datos de carga
            socket.emit('newCargaCuenta', {
                formData,
                fileUrl,
                now
            });

            setEspera(true);  // Mostrar el mensaje de espera
        } catch (error) {
            console.error('Error al subir el comprobante:', error);
            Swal.fire('Hubo un problema al enviar el comprobante.');  // Manejo de errores en la carga del archivo
        } finally {
            setFile(null);  // Reiniciar el archivo después de la carga
        }
    };

    return (
        <div className="payment-container">
            <h2 className="payment-title">MODOS DE PAGO</h2>
            <div className="payment-method">
                <img
                    src="./img/logos/logoNequi.jpg"
                    alt="Nequi"
                    className="payment-logo"
                />
                <p className="payment-info">
                    <strong>NEQUI</strong> <br />
                    <span className="payment-phone">Número de cuenta: {dataEmpresa.nequi}</span>
                    <button onClick={handleCopy} className="copy-button">
                        <FaCopy />
                    </button>
                    <br />
                    Titular: {dataEmpresa.titularNequi}
                </p>
            </div>
            <h3 className="receipt-title">COMPROBANTE DE PAGO</h3>
            <p className="instructions">
                1. Realiza el pago al número de Nequi: <strong>{dataEmpresa.nequi}</strong>.
                <br />
                2. Coloca el monto que deseas recargar, recuerda que debe ser <strong>minimo $10.000.</strong>
                <br />
                3. Carga el comprobante del pago.
                <br />
                4. Espera la confirmación de 1 a 12 horas.
            </p>
            <form onSubmit={handleSubmit} className="payment-form">
                <div className="form-group">
                    <label>Monto a Recargar (en pesos):</label>
                    <input
                        type="number"
                        name="monto"
                        value={formData.monto}  // Vincular el valor del input con formData
                        onChange={handleChange}
                        className="input-field"
                        required
                        min={10000}
                    />
                </div>
                <div className="form-group">
                    <label>Subir Comprobante:</label>
                    <input
                        type="file"
                        onChange={handleFileChange}  // Manejador de cambio de archivo
                        className="input-file"
                    />
                </div>
                {espera && (
                    <div className="espera">Enviando solicitud, espera un momento por favor</div>  // Mostrar mensaje de espera si el estado lo indica
                )}
                <button type="submit" className="submit-btn">Confirmar</button>
            </form>
            {cargaNequi && (
                <div className="content-nequi">
                    {/* Mostrar tarjetas de carga Nequi, cada tarjeta debe tener una key única */}
                    {cargaNequi.map((data, index) => (
                        <CargaNequitarjet key={data.id || index} data={data} socket={socket} dataUser={dataUser} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default CargaNequi;
